import API from "shared/services/Api";
import { ISendWhatsapp } from "shared/types/SendReferral";

export const sendWhatsapp = async (data: ISendWhatsapp, userId: string) =>
  API.post(`oc/referrals/send-number?id=${userId}`, data);
